<!--
分配弹窗,
分配作业和分配测试
静态，查询成员逻辑完成
-->
<template>
  <div class="dis-main">
    <el-dialog :title="this.dialogTitle" @close="closeDialog" :showClose='false' :visible.sync="dialogVisible">
      <div class="line-box"></div>
      <el-table :data="tableData" ref="multipleTable" border height="431" @selection-change="handleSelectionChange"
        :header-cell-style="{
          background: '#F3F7FE',
          'padding': '0',
          'height': '48px',
          color: '#566087',
        }" style="width: 100%">
        <el-table-column type="selection" class-name="select-box" width="50" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('projectV2.index')" type="index" width="50"
          align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('jobManagementV2.userName')" prop="aliasName"
          align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('jobManagementV2.role')" prop="roleName" align="center">
          <template slot-scope="scope">
            <span>
              {{ getroleName(scope.row) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('jobManagementV2.email')" :show-overflow-tooltip="true" prop="email" width="205"
          align="center">
          <template slot-scope="{ row }">
            {{ row.email || '--' }}
          </template>
        </el-table-column>
        <!-- 独立部署显示为邮箱，飞译都显示 -->
        <el-table-column :label="$t('jobManagementV2.phone')" align="center" prop="loginPhone"
          v-if="!(IS_PRIVATE || IS_ONLINE_PRIVATE)" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.loginPhone || '--' }}
          </template>
        </el-table-column>

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("projectV2.cancel")
        }}</el-button>
        <el-button type="primary" v-preventReClick @click="assignTasks()">{{
          $t("projectV2.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { companyUser, fileAppoint } from '../../../../services/jobManagement';
import _ from 'lodash';
export default {
  name: 'CatWebPcIndex',
  props: ['deadline', 'testLimitTime'],
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE,
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      dialogVisible: false,
      tableData: [],
      fileId: null,
      userList: [],
      limitTime: null,
      dialogTitle: '',
      page: 1,
    };
  },
  created() {
    if (this.$route.path === '/home/jobManagement/studentTask' || this.$route.path === '/home/jobManagement/jobDetails') {
      this.dialogTitle = this.$t('jobManagementV2.AssignTask');
    } else {
      this.dialogTitle = this.$t('jobManagementV2.AssignTest');
    }
  },
  mounted() {
    this.bus.$on('busParams', (val) => {
      this.dialogVisible = val.dialogVisible;
      this.fileId = val.id;
      this.limitTime = val.limitTime + ':00';
      this.page = val.page;
    })
  },
  destroyed() {
    this.bus.$off('busParams')
  },
  methods: {
    //获取角色名称
    getroleName(row) {
      switch (row.roleId) {
        case 1:
          return this.$t('managementV2.superManger')
        case 2:
          return this.$t('statistics.administrator')

        case 3:
          return this.$t('project.projectManager')

        case 4:
          return this.$t('statistics.resourceManager')

        case 5:
          return this.$t('stat.checking')
        case 6:
          return this.$t('project.interpreter')

      }
    },
    // 查询用户
    queryUser() {
      let params = {
        isContainSelf: 0,
        taskType: 1,
        fileId: this.fileId
      };
      companyUser(params).then(({ result }) => {
        this.tableData = result;
      })
    },

    // 分配任务
    assignTasks: _.throttle(function () {
      let arr = [];
      // console.log(this.userList);
      this.userList.map(item => {
        arr.push({
          userId: item.userId,
          limitTime: this.limitTime,
          proportion: "100",
          fileId: this.fileId
        })
      })
      let params = {
        fileId: this.fileId,
        appointType: 3,
        taskType: 1,
        transFileTaskDtoList: arr
      }

      fileAppoint(params).then(({ success }) => {
        if (success) {
          this.$message.success(this.$t('jobManagementV2.AssignSuccess'))
          this.dialogVisible = false;
          if (this.$parent.queryJob) {
            this.$parent.queryJob(this.$parent.pageDto.page, this.$parent.pageDto.sort);
          } else {
            this.$parent.queryStudentPro();
          }
        } else {
          if (params.transFileTaskDtoList.length == 0) {
            this.$message.closeAll()
            this.$message.warning(this.$t('jobManagementV2.assignRoles'))
          } else if (new Date() > new Date(this.deadline)) {
            console.log(new Date(this.deadline));
            this.$message.closeAll()
            this.$message.warning(this.$t('jobManagementV2.jobDeadline'))
          } else if (new Date() > new Date(this.testLimitTime)) {
            this.$message.closeAll()
            this.$message.warning(this.$t('jobManagementV2.distributionWarning'))
          }

        }
      })
    },),
    handleSelectionChange(val) {
      this.userList = val;
    },
    closeDialog() {
      this.fileId = null;
      this.$refs.multipleTable.clearSelection();
    }
  },
  watch: {
    fileId: {
      handler(val) {
        if (val) {
          this.queryUser();
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
